export enum ActionFieldType {
  Products = 'products',
  Category = 'category'
}
